export enum LicenseStepModelType {
  registration = 0,
  maintenance = 1,
  renewal = 2
}